<div class="app-faqs">
    <div class="content-faqs">
        <p class="tittle-faqs">Preguntas frecuentes</p>
        <div class="faqs">
            <mat-accordion>
                <mat-expansion-panel *ngFor="let item of dataAccess | keyvalue; let i = index">
                    <mat-expansion-panel-header (click)="datanicals(item)">
                        <mat-panel-title>
                            {{ 'FAQS.QUESTIONS.' + (i + 1) | translate}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [innerHTML]="'FAQS.ANSWERS.' + (i + 1) | translate"></div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>